import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'

const MakeAppointmentButton = ({ className, onClick, ...props }) =>
  <Button
    className={ className }
    onClick={ onClick }
    { ...props } />

export default MakeAppointmentButton

MakeAppointmentButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}
